import React, { useEffect } from "react";
import { Button, ContactForm, DynamicVideoCarousel, } from "../components/template";
import { Link } from "react-router-dom";
import RebootPopup from "./RebootPopup";
const HeroSection = () => {
  useEffect(() => {
    const img = new Image();
    img.src = "/assets/home/B1.jpg"; // Preload image
  }, []);
  const benefits = [
    { icon: "❤️", text: "Recharge Your Health & Energy" },
    { icon: "🧠", text: "Renew Your Focus & Clarity" },
    { icon: "✨", text: "Regain Your Inner Peace & Joy" },
    { icon: "🎯", text: "Rediscover Your Purpose & Potential" },
  ];
  const offerings = [
    {
      title: "Transformative Retreats",
      description:
        "Powerful holistic wellness programs for deep rejuvenation & inner transformation. A unique mix of Positive Psychology, Yoga, Meditation, and Ayurveda.",
      image: "/assets/home/Transformative Retreats.jpeg",
      link:"/retreats",
    },
    {
      title: "Corporate Programs",
      description:
        "Scientifically crafted programs to boost your team’s health, productivity, motivation, and team spirit based on the powerful mix of Positive Psychology, Deep Work, Mindfulness, and Yoga.",
      image: "/assets/home/Corporate.jpeg",
      link:"/corporate-wellness",
    },
    {
      title: "Online Programs",
      description:
        "Self-learning programs with actionable insights and easy-to-integrate techniques to start your holistic wellbeing journey from the comfort of your home.",
      image: "/assets/home/Online programs.jpg",
      link:"/online-programs",
    },
  ];
  const statusPoints = [
    { icon: "🧘", text: "Holistic Approach" },
    { icon: "🔬", text: "Scientific Techniques" },
    { icon: "🌟", text: "Long-lasting Benefits" },
    { icon: "🎯", text: "Customized Experience" },
    { icon: "📝", text: "Concrete Takeaways" },
    { icon: "🤝", text: "Continuous Support" },
  ];
  const testimonialVideos = [
    "https://www.youtube.com/embed/yz4INHZkJNI",
    "https://www.youtube.com/embed/0E8hm2fdxCs",
    "https://www.youtube.com/embed/cHuh-cGuYmg",
  ];
  
  const para="Have a query, want to partner with us or join our team? Write to us now:"
  return (
    <>
    <RebootPopup/>
    <section
      className="relative w-full   md:h-[80vh] flex items-center bg-cover bg-center text-white px-6"
      style={{ backgroundImage: "url('/assets/home/B1.jpg')" }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>

      {/* Content Wrapper */}
      <div className="relative z-10 flex flex-col md:flex-row items-center md:items-start justify-between max-w-6xl mx-auto w-full">
        {/* Left Content */}
        <div className=" md:max-w-md   md:text-left">
          <h1 className="text-3xl mt-8 mb:text-center sm:text-4xl md:text-5xl font-bold text-primary mb-6">
            Unlock The Best of You
          </h1>

          <ul className="space-y-4 text-left">
  {benefits.map((benefit, index) => (
    <li key={index} className="flex items-center gap-3 text-lg">
      <span className="text-2xl bg-white bg-opacity-20 p-2 rounded-full">
        {benefit.icon}
      </span>
      <span className="font-semibold">{benefit.text}</span>
    </li>
  ))}
</ul>
</div>

        {/* Call-to-Action Button */}
        <div className="mt-8 md:mt-60 mb-5  flex justify-center md:justify-start">
          <Button text="Book Innergise Retreat" variant="primary" size="md" link="/retreats/innergise" />
        </div>
      </div>
    </section>
    <section className="py-12 bg-gray-100 relative">
  <div className="max-w-6xl mx-auto px-4 sm:px-6">
    <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-8 sm:mb-12 text-secondary">
      Our Offerings
    </h2>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
      {offerings.map((offering, index) => (
        <div
          key={index}
          className="bg-white shadow-md rounded-lg overflow-hidden transition-transform transform hover:scale-105 relative z-30 h-full flex flex-col"
        >
          <img
            src={offering.image}
            alt={offering.title}
            className="w-full h-36 sm:h-44 md:h-48 object-cover"
          />
          <div className="p-4 sm:p-6 flex flex-col flex-grow">
            <h3 className="text-lg sm:text-xl font-semibold text-primary">
              {offering.title}
            </h3>
            <p className="text-gray-600 text-sm sm:text-base mt-2 flex-grow">
              {offering.description}
            </p>
            <a
              href={offering.link}
              className="inline-block mt-3 sm:mt-4 text-blue-600 font-semibold text-sm sm:text-base hover:text-blue-800 transition"
            >
              Explore Now →
            </a>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>
<section className="py-12 bg-white">
  <div className="max-w-6xl mx-auto px-4 sm:px-6 flex flex-col md:flex-row items-center">
    {/* Image Section */}
    <div className="md:w-1/2 flex justify-center">
      <img
        src="/assets/home/Why choose Param.jpg"
        alt="Holistic Wellbeing"
        className="rounded-3xl shadow-lg w-full max-w-xs sm:max-w-sm"
      />
    </div>

    {/* Text Content */}
    <div className="md:w-1/2 mt-6 md:mt-0 md:pl-8">
      <h2 className="text-2xl sm:text-3xl font-bold text-secondary text-center md:text-left">
        Why Choose PARAM Life?
      </h2>
      <p className="text-gray-600 mt-3 sm:mt-4 text-sm sm:text-base text-center md:text-left">
        Our unique methodology combines Positive Psychology, Yoga, and Ayurveda
        to help you achieve holistic well-being across physical, mental, and
        spiritual dimensions.
      </p>

      {/* Two-Column List */}
      <div className="grid grid-cols-2 gap-x-4 gap-y-3 mt-5 sm:mt-6">
        {statusPoints.map((item, index) => (
          <div key={index} className="flex items-center gap-2 text-sm sm:text-base">
            <span className="text-xl sm:text-2xl bg-gray-100 p-2 rounded-full flex-shrink-0">
              {item.icon}
            </span>
            <span className="font-semibold text-primary leading-tight sm:leading-normal">
              {item.text}
            </span>
          </div>
        ))}
      </div>
    </div>
  </div>
</section>
      <section className="md:py-8 py-6 bg-[#F1E5D9]">
        <div className="container mx-auto px-4">
          <DynamicVideoCarousel heading="Impact Stories" videos={testimonialVideos} />
        </div>
      </section>

      <section className="bg-secondary text-white py-12 sm:py-16 px-6 sm:px-12 md:px-16 lg:px-20 shadow-lg relative">
  <div className="max-w-5xl relative z-10 text-center mx-auto">
    <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold md:mb-6 mb-5  text-white">
      Who We Are
    </h2>
    <p className="text-sm sm:text-base md:text-lg leading-relaxed opacity-95">
    “Param” is a Sanskrit word which means the highest, the ultimate, the most supreme. At Param Life, we empower people to live at their highest potential — where success doesn’t cost health, ambition doesn’t make you emotionally void, and happiness isn’t an afterthought. We believe the best life isn’t about compromise — it’s about wholeness, where success, prosperity, purpose, vibrant health, fulfilling relationships, and deep inner joy co-exist.</p>
    <p className="text-sm sm:text-base md:text-lg leading-relaxed opacity-95">
      Param’s founding team – Gaurv and Monika, are alumni of prestigious
      institutes – IIT Kharagpur and IIM Lucknow. Having been in leadership
      roles at multiple reputed corporates, they discovered that growing up
      the ladder of conventional success alone is insufficient to offer
      genuine and lasting fulfillment. 
    </p>
  </div>
  <div className="mt-6 sm:mt-8 text-center">
  <Link 
    to="/about" 
    className="underline text-white font-semibold py-2 px-4 rounded-md md:mb-5 mb-3 w-auto "
  >
    Know More About Us
  </Link>
</div>
</section>
<section className="bg-light text-gray-700 py-12 sm:py-16 px-6 sm:px-12 md:px-16 lg:px-20 shadow-lg relative">
  
  <div className="max-w-5xl mx-auto text-center">
  <h2 className="text-2xl sm:text-3xl font-bold text-secondary text-center md:mb-6 mb-4">
Know Yourself      </h2>

    <p className="text-sm sm:text-base md:text-lg leading-relaxed mb-6 sm:mb-8">
      Discover more about your personality, health, and wellness through engaging and informative quizzes, blogs, and videos.
    </p>
  </div>

  {/* Card Section */}
  <div className="flex flex-col md:flex-row bg-white shadow-md rounded-lg overflow-hidden max-w-4xl mx-auto">
    {/* Image & Heading */}
    
    <div className="w-full md:w-1/2 p-6 flex flex-col justify-center items-center border-b md:border-b-0 md:border-r border-gray-300">
      <img
        src="/assets/home/prakriti Quiz.png"
        alt="Wellness Quiz"
        className="w-32 sm:w-40 md:w-56 lg:w-56 mb-4"
      />
    </div>

    {/* Text & Button */}
    <div className="w-full md:w-1/2 p-6 flex flex-col justify-center">
    <h3 className="text-lg sm:text-xl font-semibold mb-2 text-center">
        Prakriti Quiz
      </h3>
      
      <p className="text-sm sm:text-base text-gray-700 mb-4">
        Discover your Mind-Body Type with this simple quiz to make smarter choices for a balanced and healthier life.
      </p>
      <div className="mt-6 sm:mt-8 text-center">
  <Link 
    to="/wellness-quiz/know-your-prakriti" 
    className="underline text-primary font-bold py-2 px-4 rounded-md md:mb-5 mb-3 w-auto "
  >
    Take the Quiz
  </Link>
</div>

    </div>
  </div>

  {/* Explore More Link */}
  <div className="mt-6 text-center sm:text-right max-w-5xl mx-auto">
    <a href="/wellness-blogs" className="text-blue-800  underline text-sm sm:text-base">
      Explore More
    </a>
  </div>
</section>
    <section className="bg-accent flex flex-col items-center justify-center py-8">
  <h2 className="text-3xl md:text-4xl text-center font-bold text-secondary mb-4">
    Get in Touch
  </h2>
  <ContactForm para={para} />
</section>
</>  
  );
};

export default HeroSection;
